export const getConfig = () => {
  const config = {
    environment: process.env.NODE_ENV,
    baseURL: process.env.REACT_APP_BACKEND_URL,
    GoogleAnalyticsTrackingId:
      process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID,
    GoogleOAuthID: process.env.REACT_APP_GOOGLE_OAUTH_ID,
    FeatureTravel: Boolean(process.env.REACT_APP_FEATURE_TRAVEL === "true"),
    FeatureShopping: Boolean(process.env.REACT_APP_FEATURE_SHOPPING === "true"),
    FeatureCareer: Boolean(process.env.REACT_APP_FEATURE_CAREER === "true"),
    FeatureBlog: Boolean(process.env.REACT_APP_FEATURE_BLOG === "true"),
    FeatureOGPayment: Boolean(process.env.REACT_APP_CONNECT_OG_PAYMENT === "true"),
    BlogURL: process.env.REACT_APP_BLOG_URL,
  };
  return config;
};
